const PRODUCTS_FIELD_POLICY = {
  keyArgs: false,
  read(existing, {
    args
  }) {
    var _args$productApiNames;
    if (!existing) {
      return undefined;
    }
    const requestedProducts = (_args$productApiNames = args === null || args === void 0 ? void 0 : args.productApiNames) !== null && _args$productApiNames !== void 0 ? _args$productApiNames : [];
    const hasAllProductsInCache = requestedProducts.every(name => existing.productsByName[name] !== undefined);
    return hasAllProductsInCache ? existing : undefined;
  },
  merge(existing, incoming) {
    if (!existing) {
      return incoming;
    }
    return Object.assign({}, incoming, {
      productsByName: Object.assign({}, existing.productsByName, incoming.productsByName)
    });
  }
};
export const PUBLIC_PRODUCTS_FIELD_POLICIES = {
  com_hubspot_buying_rpc_PublicProductRpc_getPublicProductsV2: PRODUCTS_FIELD_POLICY
};